export function getEditorPointerUniqueId(editorPointer) {
  var _editorPointer$docume, _editorPointer$innerE;
  return `${(_editorPointer$docume = editorPointer.documentPointer) == null ? void 0 : _editorPointer$docume.id}${((_editorPointer$innerE = editorPointer.innerElementPath) == null ? void 0 : _editorPointer$innerE.join('')) ?? ''}`;
}
//# sourceMappingURL=getEditorPointerUniqueId.js.map